import { createContext } from 'react';

interface IPlaceholderContext {
  startToCollect?: (env?: string, opts?: any) => void | undefined;
  setUserInfo?: () => void;
  userInfo?: Record<string, unknown>;
  isLogin?: boolean;
  openModel?: (...arg: any) => void;
  isLoading?: boolean;
  loginSuccess?: boolean;
  registerSuccess?: boolean;
  getChannelInfo?: () => void | undefined;
  pushEvent?: (ea?: string, ec?: string, el?: string) => void | undefined;
  pushToSignUp?: any;
  SensorsStart?: (option: any) => void | undefined;
  SensorsTrack?: (type: string, data?: any) => void | undefined;
}
export const PlaceholderContext = createContext<IPlaceholderContext>({
  startToCollect: null,
  setUserInfo: null,
  userInfo: null,
  isLogin: false,
  openModel: null,
  isLoading: true,
  loginSuccess: false,
  registerSuccess: false,
});

export const PlaceholderProvider: React.FC<any> = ({ children, ...props }) => {
  return (
    <PlaceholderContext.Provider value={{ ...props }}>
      {children}
    </PlaceholderContext.Provider>
  );
};
